<template>
  <div class="container">
    <div class="row">
      <div class="col-48 position-relative slider-container d-flex flex-column  justify-content-center ">
        <div class="white-circle"></div>
        <div class="slider-intro mx-auto">
          <h3 class="text-green">What type of Service
            are you looking for?</h3>
          <p>SELECT FROM ONE OF THE OPTIONS BELOW</p>
        </div>
        <Carousel :itemsToShow="3" :wrapAround="true">
          <Slide v-for="image in images" :key="image.id">
            <div class="carousel__item d-flex flex-column">
              <img :src="image.url" />
              <button class="btn btn-primary" @click="nextStep">{{image.type}}</button>
            </div>
          </Slide>
          <template #addons>
            <Navigation />
          </template>
        </Carousel>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    defineComponent
  }
  from 'vue'
  import {
    Carousel,
    Pagination,
    Slide,
    Navigation
  }
  from 'vue3-carousel';

  import 'vue3-carousel/dist/carousel.css';

  export default defineComponent( {
    name: 'Breakpoints',
    components: {
      Carousel,
      Slide,
      Pagination,
      Navigation,
    },
    data: () => ( {

      images: [ {
          id: 1,
          url: "https://picsum.photos/300/200?q=1",
          type: "prevention"
        },
        {
          id: 2,
          url: "https://picsum.photos/300/200?q=2",
          type: "intervention"
        },
        {
          id: 3,
          url: "https://picsum.photos/300/200?q=3",
          type: "treatment centre"
        },
        {
          id: 4,
          url: "https://picsum.photos/300/200?q=4",
          type: "prevention"
        },
      ],
      // carousel settings
      settings: {
        itemsToShow: 1,
        snapAlign: 'center',
      },
      // breakpoints are mobile first
      // any settings not specified will fallback to the carousel settings
      breakpoints: {
        // 700px and up
        700: {
          itemsToShow: 3.5,
          snapAlign: 'center',
        },
        // 1024 and up
        1024: {
          itemsToShow: 2,
          snapAlign: 'center',
        },
      },
    } ),
  } );

</script>
<style lang="scss">
// @import '@/assets/app.scss';
</style>
